import { PedigreeData } from '../../../admin/vue/mixins/PedigreeData'
import NodeLoader from './NodeLoader.vue'
import "skeleton-screen-css"

export default {
    components: { NodeLoader },
    props: {
        pedigrees: {
            type: Object | Array,
            default() {
                return null
            },
        },
        systemPedigree: {
            type: Boolean,
            default: false,
        },
        showHorseLink: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },

    mounted() {
        // merge pedigree from server with the local pedigree
        if (this.pedigrees) {
            this.pedigreeStructure = this.merge(this.pedigreeStructure, this.pedigrees)
        }

        this.show = true
    },

    mixins: [PedigreeData],

    methods: {
        setPedigreeData(pedigree) {
            if (pedigree) {
                this.pedigreeStructure = this.merge(this.pedigreeStructure, pedigree)
            }
        }
    },

    data() {
        return {
            show: false,
        }
    },
}
